import {displayString} from '#tools/user'
import PropTypes from 'prop-types'
import React from 'react'
import {useSelector} from 'react-redux'

function UserName({userToDisplayInfo, fallbackUsername}) {
  const userId = useSelector(state => state.authentication.id)

  return <div className="userName">{displayString(userId, userToDisplayInfo, fallbackUsername)}</div>
}

UserName.propTypes = {
  userToDisplayInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.number,
  }),
  fallbackUsername: PropTypes.string,
}

export default UserName
